// extracted by mini-css-extract-plugin
var _1 = "carousel-container__ZvBuh";
var _2 = "carousel-grid__ZB7F2";
var _3 = "carousel-inner-container__H5TBx";
var _4 = "carousel-outer-container__WA7kz";
var _5 = "description-container__wHJkQ";
var _6 = "dots__bICP6";
var _7 = "dots-dark__NQLix";
var _8 = "dots-light__D6mdG";
var _9 = "image-container__ru0bn";
var _a = "link-button__g1lSn";
var _b = "nav-arrow__D4ap1";
var _c = "nav-arrow-container__qCHXi";
var _d = "nav-arrow-dark__qkEol";
var _e = "nav-arrow-light__yLXxJ";
var _f = "next-arrow__sJ2wr";
var _10 = "prev-arrow__NXsBS";
var _11 = "slider__V2Mxm";
export { _1 as "carouselContainer", _2 as "carouselGrid", _3 as "carouselInnerContainer", _4 as "carouselOuterContainer", _5 as "descriptionContainer", _6 as "dots", _7 as "dotsDark", _8 as "dotsLight", _9 as "imageContainer", _a as "linkButton", _b as "navArrow", _c as "navArrowContainer", _d as "navArrowDark", _e as "navArrowLight", _f as "nextArrow", _10 as "prevArrow", _11 as "slider" }
